module.exports = __webpack_public_path__ + "static/media/ZazoSell.4b914f8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/ZazoSell.png
// module id = 450
// module chunks = 0